//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import {
  IAutomationConfigurations,
  IGetAutomationConfigurationsResponse,
} from '@apis/rights-management/rightsAutomationApiModel';
import PartialCuid from '@models/PartialCuid';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

const RIGHTS_AUTOMATION_DEFAULT_ENDPOINT = '/api/v1';

function webGatewayFetch(
  endpoint: string,
  init?: RequestInit,
): Promise<ISerializedResponse> {
  return serializedGatewayFetch(
    'web_gateway',
    `${RIGHTS_AUTOMATION_DEFAULT_ENDPOINT}${endpoint}`,
    init,
  );
}

/**
 * Gets the client's rights automation configuration
 *
 * GET /api/v1/rights/automated/config
 */

export const getAutomationConfigurations =
  async (): Promise<IAutomationConfigurations> => {
    const res = await webGatewayFetch(`/rights/automated/config`);
    const json = await res.json<IGetAutomationConfigurationsResponse>();
    return json.data;
  };

/**
 * Updates an existing rights automation configurations
 *
 * PUT /api/v1//rights/automated/config
 */

export const updateAutomationConfigurations = async (
  automationConfigurations: IAutomationConfigurations,
): Promise<Response> => {
  return webGatewayFetch(`/rights/automated/config`, {
    method: 'PUT',
    body: JSON.stringify(automationConfigurations),
  });
};

/**
 * Send Cuids to right automation
 *
 * POST /api/v1/rights/automated/requests
 */
export const sendContentsToRightAutomation = async (
  cuids: PartialCuid[],
): Promise<Response> => {
  const params = {
    itemIds: cuids,
  };
  return await webGatewayFetch(`/rights/automated/requests`, {
    body: JSON.stringify(params),
    method: 'POST',
  });
};
